import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ModalTitle = ({
  title, subtitle, children, styles, style
}) => (
  <div className="generic-modal-title-container" style={styles.modalTitle || style}>
    {
      children || (
        <>
          {title && <div className="generic-modal-title">{title}</div>}
          {subtitle && <div className="generic-modal-subtitle">{subtitle}</div>}
        </>
      )
    }
  </div>
);

ModalTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  styles: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

ModalTitle.defaultProps = {
  title: '',
  subtitle: '',
  style: {},
  styles: {},
  children: null
};

export default memo(ModalTitle);
